import validateCacheRequest from 'owa-service/lib/factory/validateAggregatedConfigurationRequest';
import validateCacheOperation from 'owa-service/lib/operation/validateAggregatedConfigurationOperation';
import { action } from 'satcheljs/lib/legacy';
import { isAnonymousUser } from 'owa-config/lib/anonymousUtils';

export default action('validateCache')(function validateCache() {
    !isAnonymousUser() && validateCacheOperation(validateCacheRequest({}));
});
